import React from "react";
import { ArrowRight } from "lucide-react";
import { useContent } from "@/contexts/ContentContext";
import { iconFor } from "@/lib/icons";
import { resolveCtaHref } from "@/lib/cta";
import { trackCta } from "@/lib/analytics";

export const SmartWork = () => {
    const { content } = useContent();
    const s = content.smart_work;
    const stages = s.stages || [];
    const ctaHref = resolveCtaHref(
        { cta_kind: s.cta_kind || "whatsapp", cta_url: s.cta_url || "", title: "SMART-WORK Transformation" },
        content.contact,
    );

    return (
        <section id="smart-work" data-testid="smart-work-section" className="bg-[#0A192F] text-white py-24 lg:py-28 relative overflow-hidden">
            <div className="absolute -top-32 -right-32 w-[480px] h-[480px] bg-teal-500/10 blur-3xl rounded-full pointer-events-none" />
            <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
                <div className="grid lg:grid-cols-12 gap-10 items-end">
                    <div className="lg:col-span-8">
                        <p className="label-eyebrow !text-teal-300">{s.eyebrow}</p>
                        <h2 data-testid="smart-work-title" className="mt-4 font-display font-semibold text-white text-3xl sm:text-4xl lg:text-[42px] leading-[1.1] tracking-tight">{s.title}</h2>
                        <p className="mt-4 text-lg text-slate-300 font-body leading-relaxed">{s.subtitle}</p>
                    </div>
                    <div className="lg:col-span-4 flex lg:justify-end">
                        <span className="inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.2em] text-slate-400">
                            <span className="w-8 h-px bg-teal-400" />{s.availability_label}
                        </span>
                    </div>
                </div>

                <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-5">
                    {stages.map((stage, idx) => {
                        const Icon = iconFor(stage.icon);
                        return (
                            <div key={`${stage.title}-${idx}`} data-testid={`smart-work-stage-${idx + 1}`} className="relative border border-white/10 bg-white/[0.03] p-6 hover:bg-white/[0.06] hover:border-teal-400/40 transition-all">
                                {idx < stages.length - 1 && (
                                    <ArrowRight className="hidden lg:block absolute -right-4 top-9 w-6 h-6 text-teal-400/70" strokeWidth={1.5} />
                                )}
                                <div className="flex items-center justify-between">
                                    <span className="inline-flex items-center justify-center w-10 h-10 border border-teal-400/40 text-teal-300">
                                        <Icon strokeWidth={1.5} className="w-5 h-5" />
                                    </span>
                                    <span className="font-display text-sm font-semibold text-slate-500">{stage.n}</span>
                                </div>
                                <h3 className="mt-6 font-display text-xl font-semibold text-white">{stage.title}</h3>
                                <p className="mt-3 text-[13.5px] text-slate-300 font-body leading-relaxed">{stage.desc}</p>
                            </div>
                        );
                    })}
                </div>

                <div className="mt-14">
                    <a
                        href={ctaHref}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="smart-work-cta"
                        onClick={() => trackCta("smart_work_consultation_click", { source: "smart_work_section" })}
                        className="btn-base btn-primary"
                    >
                        {s.cta_label}
                        <ArrowRight className="w-4 h-4" />
                    </a>
                </div>
            </div>
        </section>
    );
};

export default SmartWork;
